module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is a work of nonfiction. Most of the spoken words were taken from interviews, wire taps, court testimonies and newspaper articles, were reconstructed by eyewitnesses to the events or have been recounted to me. I have attributed thoughts to some of the characters, and all of these were plausibly described to me. I describe criminal proceedings and cite various documents relating to them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While growing up in Revere, I have not only personally known the men mentioned in this book, such as Sean Cote, Paul Strazzula, Eddie Portalla and Gigi Portalla, but I have associated with them from time to time as well. I have had and continue to have a very close personal friendship with the Portalla family. I also personally know and have interviewed some of the Revere Police officers mentioned in this book. Many of the stories and their details have never been revealed until now.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f162938","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authorsnote.vue
// module id = 69
// module chunks = 0